import { render } from "./ProfileNavItem.vue?vue&type=template&id=24192ec9"
import script from "./ProfileNavItem.vue?vue&type=script&lang=js"
export * from "./ProfileNavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__